import React from "react";
import "./How_we_work.css";
import { IDS } from "../../../utils/common";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Common_heading from "../../common/common_heading/Common_heading";
import { useNavigate } from "react-router-dom";

function How_we_work() {
  const navigate = useNavigate();

  // ✅ STATIC DATA (REPLACED API)
  const whychooseus = [
    {
      image: "/assets/images/home/why-choose-us/people.png",
      name: "1. CONNECTION",
      sub: "(INITIAL CONTACT)",
      description:
        "The first step is reaching out. You share your ventilation challenges with the company, and they focus on finding the most cost-effective & efficient solutions for your specific needs.",
    },
    {
      image: "/assets/images/home/why-choose-us/construction-site.png",
      name: "2. SITE EXAMINATION",
      sub: "(ASSESSMENT)",
      description: `A professional engineer visits your location. Their job is to:
• Inspect the physical layout of your premises.
• Understand the specific workflow.
• Collect technical data necessary for a custom design.`,
    },
    {
      image: "/assets/images/home/why-choose-us/analyze.png",
      name: "3. ANALYZE",
      sub: "(DATA REVIEW)",
      description:
        "Back at the office, the team reviews all the gathered information. They perform technical calculations to ensure they provide a ventilation solution that is accurate, effective, and tailored to your space.",
    },
    {
      image: "/assets/images/home/why-choose-us/reputation.png",
      name: "4. CLIENT VALIDATION",
      sub: "(FINAL APPROVAL)",
      description:
        "The final stage is a collaborative meeting. The company presents the detailed proposal to you for a thorough discussion, making any necessary adjustments until you are ready to give the final approval.",
    },
  ];

  return (
    <section className="How_we_work">
      <div className="custom_container">
        <div className="How_we_work_holder">
          <Common_heading
            heading={"HOW WE WORK"}
            subHeading={"PRECISION SOLUTIONS THAT SET US APART"}
          />

          <div className="row g-4 justify-content-center">
            {whychooseus.map((card, index) => (
              <div
                key={index}
                className="col-12 col-md-6 col-lg-4 col-xl-3 col-sm-6 custom_col"
              >
                <div className="why_card h-100 p-4 text-start">
                  <div className="icon mb-3">
                    <img
                      src={card.image}
                      alt={card.name}
                      className="why_icon_img"
                    />
                  </div>

                  <h5>{card.name}</h5>
                  <h6>{card.sub}</h6>

                  <p style={{ whiteSpace: "pre-line" }}>{card.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="contact_strip_holder">
            <div className="text_holder">
              <h2>Have a Requirement? </h2>
              <h3>Get In Touch With Us Today</h3>
              <div className="hr_holder"></div>

              <div className="disc_text_holder">
                <p>
                  Reach out today & experience service that delivers precision,
                  performance, and trust.
                </p>

                <Common_Btn
                  onClick={() => navigate("/contact-us")}
                  text={
                    <>
                      CONTACT US <FontAwesomeIcon icon={faAngleRight} />
                    </>
                  }
                />
              </div>

              <div className="bg_img_holder bg_1">
                <img
                  src="/assets/images/home/how_we_work/cooler.png"
                  alt="bg"
                  className="bg_img"
                />
              </div>

              <div className="bg_img_holder bg_2">
                <img
                  src="/assets/images/home/how_we_work/fan.png"
                  alt="bg"
                  className="bg_img"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="banner_img_holder">
          <img
            src={"/assets/images/home/how_we_work/digital.png"}
            className="banner_img"
            alt="banner"
          />
        </div>
      </div>
    </section>
  );
}

export default How_we_work;
